import { render, staticRenderFns } from "./ProductMaterialsList.vue?vue&type=template&id=36adfc62&scoped=true&"
import script from "./ProductMaterialsList.vue?vue&type=script&lang=js&"
export * from "./ProductMaterialsList.vue?vue&type=script&lang=js&"
import style0 from "./ProductMaterialsList.vue?vue&type=style&index=0&id=36adfc62&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36adfc62",
  null
  
)

export default component.exports